import type { AdminFeedbackListItemResponse } from "../../../types/adminTypes";

export const getFeedbackTypeLabel = (type: AdminFeedbackListItemResponse["type"]) => {
  switch (type) {
    case "QUESTION":
      return "Question";
    case "BUG":
      return "Bug report";
    case "FEATURE_IDEA":
      return "Feature idea";
    case "GENERAL_FEEDBACK":
      return "General feedback";
    case "POST_COMPLETION_WEBSITE_FEEDBACK":
      return "Completed gig website feedback";
  }
};

export const getFeedbackRoleLabel = (role: AdminFeedbackListItemResponse["respondentRole"]) => {
  if (role === "TEEN") {
    return "Teen";
  }
  if (role === "POSTER") {
    return "Poster";
  }
  return "Not tied to gig";
};
